export const props = { viewBox: "0 0 16 16" };
export const innerHTML = `
    <svg width="16" height="16" fill="none">
   <circle cx="8" cy="8" r="6" fill="#BFBFBF"/>
</svg>
`;
